import React from 'react';
import rehypeRaw from 'rehype-raw';

import ReactMarkdown from 'react-markdown';
import {
  LandingComponent,
  LandingComponentButton,
  Size,
  Color,
  BadgeColor,
  Alignment,
  DescriptionSize,
  ButtonStyle,
  ButtonSize,
} from 'app/types';
import { Link } from 'react-router-dom';
import {
  TITLESIZE,
  TEXTCOLOR,
  ALIGNMENT,
  BADGECOLOR,
  DESCRIPTIONSIZE,
  BUTTONSTYLE,
  BUTTONSIZE,
  SECTIONTITLEALIGNMENT,
} from 'common/constants';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
  isStandalone: boolean;
}
const TitlePreview = ({
  landing_cmp,
  isStandalone = true,
}: PreviewComponentProps): React.ReactElement => {
  const size: Size = landing_cmp.config.title_size;
  const titleColor: Color = landing_cmp.config.title_color;
  const sectionColor: Color = landing_cmp.config.section_title_color;
  const badgeColor: BadgeColor = landing_cmp.config.badge_color;
  const descriptionColor: Color = landing_cmp.config.description_color;
  const alignment: Alignment = landing_cmp.config.alignment;
  const descriptionSize: DescriptionSize = landing_cmp.config.description_size;

  const renderTitle = () => {
    if (landing_cmp.config.title_type === 'main') {
      return (
        <h1
          className={`ua-cms__title ${TITLESIZE[size]} ${TEXTCOLOR[titleColor]}`}
          dangerouslySetInnerHTML={{ __html: landing_cmp.config.title }}
        ></h1>
      );
    } else {
      return (
        <h2
          className={`ua-cms__title ${TITLESIZE[size]} ${TEXTCOLOR[titleColor]}`}
          dangerouslySetInnerHTML={{ __html: landing_cmp.config.title }}
        ></h2>
      );
    }
  };

  return (
    <header
      className={`${isStandalone ? 'row mx-auto' : ''} ua-cms__section-header text-center ${
        ALIGNMENT[alignment]
      }`}
    >
      <div className="col-12">
        {landing_cmp.config.section_title && (
          <h3
            className={`ua-cms__section-title mb-4 text-primary position-relative fs-5 fw-bold d-flex flex-row ${TEXTCOLOR[sectionColor]} justify-content-center ${SECTIONTITLEALIGNMENT[alignment]}`}
          >
            <span>{landing_cmp.config.section_title}</span>
          </h3>
        )}
        {landing_cmp.config.badge && (
          <h3 className={`badge rounded-pill py-3 px-4 fs-6 fw-medium ${BADGECOLOR[badgeColor]}`}>
            {landing_cmp.config.badge}
          </h3>
        )}
        {landing_cmp.config.title && renderTitle()}
        {landing_cmp.config.description && (
          <div className={`${TEXTCOLOR[descriptionColor]} ${DESCRIPTIONSIZE[descriptionSize]}`}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {landing_cmp.config.description}
            </ReactMarkdown>
          </div>
        )}
        {landing_cmp.landing_component_buttons.length > 0 &&
          landing_cmp.landing_component_buttons.map((button: LandingComponentButton) => {
            const buttonStyle: ButtonStyle = button.style as keyof typeof BUTTONSTYLE;
            const buttonSize: ButtonSize = button.size as keyof typeof BUTTONSIZE;
            return (
              <Link
                key={button.id}
                to={button.link}
                className={`btn fw-medium rounded-pill mt-4 px-5 me-sm-2 mb-3 mb-sm-0 col-12 col-sm-auto ${BUTTONSTYLE[buttonStyle]} ${BUTTONSIZE[buttonSize]}`}
              >
                {button.text}
              </Link>
            );
          })}
      </div>
    </header>
  );
};

export { TitlePreview };
